import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { type SelectOption } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'

import Select from 'modules/core/components/Inputs/Select'
import { UserSelectorInput } from 'modules/core/components/Inputs/UserSelector'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

import { filterCountries } from 'modules/app_store/lib/payrollAddonFilters'
import PayrollPolicyFormBody from 'modules/payroll_bundle/pages/settings/Components/PayrollPolicy/Form/Body'
import type PolicyForm from 'modules/payroll_bundle/pages/settings/Components/PayrollPolicy/Form/PolicyForm'
import { Country } from 'modules/payroll_bundle/store/models/PayrollBundle'
import type Policy from 'modules/payroll_bundle/store/models/Policy'

import { SHOW_BOOKKEEPER, SHOW_PAYROLL_POLICY } from './constants'

interface Props {
  stage: string
  bookkeeperIds: number[]
  policy?: Policy | null
  countriesForm: Form
  policyForm: PolicyForm
  addEmployeesToPolicy: boolean
  loadingPolicies: boolean
  setAddEmployeesToPolicy: React.Dispatch<React.SetStateAction<boolean>>
  setBookkeeperIds: (ids: number[]) => void
}

const translateCountry = (country: Country) => {
  const countryLabels: Record<Country, string> = {
    spain: i18n.t('app_store_v2.apps.payroll_bundle.install_modal.country.options.spain'),
    france: i18n.t('app_store_v2.apps.payroll_bundle.install_modal.country.options.france'),
    mexico: i18n.t('app_store_v2.apps.payroll_bundle.install_modal.country.options.mexico'),
    other: i18n.t('app_store_v2.apps.payroll_bundle.install_modal.country.options.other'),
  }

  return countryLabels[country]
}

const FormBody = ({
  stage,
  policy,
  policyForm,
  setBookkeeperIds,
  bookkeeperIds,
  countriesForm,
  loadingPolicies,
  addEmployeesToPolicy,
  setAddEmployeesToPolicy,
}: Props) => {
  const countriesOptions: SelectOption[] = React.useRef(
    filterCountries().map((country) => ({
      value: country,
      label: translateCountry(country) ?? '',
    }))
  ).current

  const currentStage = () => {
    switch (stage) {
      case SHOW_BOOKKEEPER:
        return (
          <Box gap="s24">
            <UserSelectorInput
              label={i18n.t('app_store_v2.apps.payroll_bundle.install_modal.bookkeeper.label')}
              onSubmit={setBookkeeperIds}
              selectedIds={bookkeeperIds}
              users={users.notTerminated}
              multiselect
            />
          </Box>
        )
      case SHOW_PAYROLL_POLICY:
        return (
          <PayrollPolicyFormBody
            policy={policy}
            policyForm={policyForm}
            loadingPolicies={loadingPolicies}
            addEmployeesToPolicy={addEmployeesToPolicy}
            setAddEmployeesToPolicy={setAddEmployeesToPolicy}
          />
        )
      default:
        return (
          <Select
            none={i18n.t('common.select')}
            label={i18n.t('app_store_v2.apps.payroll_bundle.install_modal.country.label')}
            field={countriesForm.get('country')}
            options={countriesOptions}
          />
        )
    }
  }

  return currentStage()
}

export default FormBody
